/// <reference path="definitions/jquery.d.ts"/>
/// <reference path="definitions/velocity.d.ts"/>

class Slide {
	$: JQuery

	constructor (el: JQuery|Element|string) {
		this.$ = jQuery(el)
		this.setBasePosition()
	}

	setBasePosition () {
		this.$.css('transform', '')
		this.$.hide()
	}

	show (effect?: string, direction?: string, callback?: any) {
		var distance = this.$.outerWidth()

		if (typeof callback !== 'function') {
			callback = function () {}
		}

		switch (effect) {
		case 'fade':
			this.$.velocity('fadeIn', {
				duration: 500,
				display: 'block'
			})
			break
		case 'move':
			this.$.velocity({
				translateX: direction === 'right' ? [0, -distance] : [0, distance]
			}, {
				duration: 500,
				display: 'block',
				easing: 'easeOutCubic',
				complete: callback
			})
			break
		default:
			this.$.show()
		}
	}

	hide (effect?: string, direction?: string, callback?: any) {
		var distance = this.$.outerWidth()

		switch (effect) {
		case 'fade':
			this.$.velocity('fadeOut', {
				duration: 500,
				display: 'none'
			})
			break
		case 'move':
			this.$.velocity({
				translateX: direction === 'right' ? [distance, 0] : [-distance, 0]
			}, {
				duration: 500,
				display: 'none',
				easing: 'easeOutCubic',
				complete: callback
			})
			break
		default:
			this.$.hide()
		}
	}
}

export default class Slideshow {
	$: JQuery
	controls: JQuery
	slides: Array<Slide> = []
	currentSlide: Slide
	currentSlideNo = 0
	delay: number = null
	animating = false

	constructor (el: JQuery|Element|string, delay: number) {
		this.$ = jQuery(el)
		this.delay = delay || null
		this.controls = this.$.find('[data-slideshow-controls]')

		this.$.find('.js-slide').each((i, element) => {
			jQuery(element).hide()
			this.slides.push( new Slide(element) )
		})

		if (this.slides.length === 0) {
			return
		}

		this.currentSlide = <Slide> this.slides[this.currentSlideNo]
		this.currentSlide.show()

		var controlElement = jQuery('<a href="#"></a>')
				.addClass('slideshow__dot')

		for (var i = 0; i < this.slides.length; i++) {
			this.controls.append( controlElement.clone().attr('data-goto', i) )
		}

		this.controls.find('.slideshow__dot').first().addClass('slideshow__dot--active')

		this.controls.on('click', '[data-goto]', (ev) => {
			ev.preventDefault()
			this.gotoSlide( parseInt(jQuery(ev.currentTarget).attr('data-goto'), 10) )
		})

		this.$.on('click', '[data-next]', (ev) => {
			ev.preventDefault()
			this.next()
		})

		this.$.on('click', '[data-previous]', (ev) => {
			ev.preventDefault()
			this.previous()
		})
		
		if (this.delay) {
			window.setInterval(() => {
				this.next();
			}, this.delay);
		}
	}

	getSlideNo (direction?: string) {
		var step, next

		switch (direction) {
		case 'previous':
			step = -1
			break
		case 'next':
			step = 1
			break
		default:
			step = 0
		}

		next = this.currentSlideNo + step

		if (next < 0) {
			return this.slides.length - 1
		} else if (next >= this.slides.length) {
			return 0
		}

		return next
	}

	gotoSlide (no: number) {
		var direction = (no < this.currentSlideNo) ? 'right' : 'left'

		if (no === this.currentSlideNo) {
			return
		}

		if (this.animating) return

		this.controls.find('.slideshow__dot')
			.removeClass('slideshow__dot--active')
			.filter('[data-goto=' + no + ']')
				.addClass('slideshow__dot--active')

		this.animating = true
		this.currentSlide.hide('move', direction, () => {})
		this.currentSlide = this.slides[no]
		this.currentSlideNo = no
		this.currentSlide.show('move', direction, () => {
			this.animating = false
		})
	}

	next () {
		this.gotoSlide( parseInt(this.getSlideNo('next'), 10) )
	}

	previous () {
		this.gotoSlide( parseInt(this.getSlideNo('previous'), 10) )
	}
}
